import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
// import Rating from 'react-rating'
import Rating from "@mui/material/Rating";
import _ from "lodash";

import { useTranslation } from "react-i18next";
import { SessionKeys } from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { CoachRatingClear, CoachRatingg } from "../../redux/coaching/actions";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Spinner } from "react-bootstrap";
import { setUserRoleClear } from "../../redux/user/actions";

const CoachRating = ({
  show,
  handleClose,
  isLoading,
  setIsLoading,
  coachId,
  coachName,
  coachImage,
  coachDesignation,
  coachExperience,
  sessionNotes,
  getCoachNotesDataReq,
  entityType,
}) => {
  const { t } = useTranslation();

  const [rating, setRating] = useState("");
  const [ratingAlert, setRatingAlert] = useState(false);
  const [comment, setComment] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  // const [hide, setHide] = useState();
  const [error, setError] = useState(false);
  const [showModalMsg] = useState(
    t("Success! Your rating has been sent. We appreciate your effort.")
  );
  const dispatch = useDispatch();
  const coachingRatingStore = useSelector(
    (state) => state.coaching.coachRating
  );

  const handleRatingChange = (event, newValue) => {
    console.log("newValue", newValue, event);
    setRating(newValue);
    setRatingAlert(false);
  };

  const handleSubmit = () => {
    console.log("coachId", coachId);
    if (rating === "") {
      setRatingAlert(true);
      return;
    }
    if (rating && coachId) {
      setIsLoading(true);
      dispatch(
        CoachRatingg({
          module: "coachRating",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            entity_id: coachId,
            rating: rating,
            remarks: comment ? comment : "",
            entity_type: entityType,
          },
        })
      );
    } else {
      // setError(true);
    }
  };
  useEffect(() => {
    console.log("coachingRatingStore: ", coachingRatingStore);
    if (!_.isEmpty(coachingRatingStore)) {
      setIsLoading(false);
      if (coachingRatingStore?.status === "success") {
        if (sessionNotes) {
          getCoachNotesDataReq();
        }
        handleClose();
        setConfirmModal(true);
        dispatch(CoachRatingClear({}));
        setRating("");
        setComment("");
        // setHide(false)
      } else {
      }
    }
  }, [coachingRatingStore]);

  const handleComment = (e) => {
    // if(e.target.value.length === 0){
    //     setHide(false);
    // }else{
    //     setHide(true)
    // }
    setComment(e.target.value);
    console.log("commentt", e.target.value);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleClose();
          setRating("");
          setRatingAlert(false);
          setComment("");
          // setHide(false)
        }}
        // backdrop={isLoading ? "static" : true}
        dialogclassName="modal-60w"
        aria-labelledby="contained-modal-title-vcenter"
        className="custom-modal rating-popup"
        centered
        size="lg"
      >
        <Modal.Header closeButton className="p-4 border-0">
          <Modal.Title className="mentor-title mb-0">
            {t("Rate Your Coach")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="rating-poupupinner">
            <div className="imgleft-box">
              <img
                src={coachImage ? coachImage : "/images/avatar.svg"}
                alt="profile"
              />
            </div>
            <div className="profile-info">
              <div className="name-cac">{coachName ? coachName : ""}</div>
              <div className="desig">
                {coachDesignation ? coachDesignation : ""}
              </div>
              <div className="ecxpe">
                {coachExperience ? `${coachExperience} Experience` : ""}
              </div>
            </div>
          </div>
          <div className="ratigx mt-3">
            <div className="input-text position-relative disable_field">
              <label htmlFor="Your Rating" className="input__label">
                {t("Your Rating")}
              </label>
              <br />
              {/* <Stack spacing={1}> */}
              <Rating
                name="half-rating"
                value={rating}
                precision={0.5}
                onChange={handleRatingChange}
                readOnly={isLoading}
              />
              <br />
              {ratingAlert && (
                <span style={{ color: "red", fontSize: ".9rem" }}>
                  {t("Your feedback matters! Please provide your rating.")}
                </span>
              )}
              {/* </Stack> */}
            </div>
            <div className="input-text position-relative ">
              <label htmlFor="Comments" className="input__label">
                {t("Comments")}
              </label>
              <textarea
                type="text"
                id="city"
                name="city"
                className="input__field"
                placeholder={t("Comments here...")}
                value={comment}
                onChange={handleComment}
                // maxLength={500}
                disabled={isLoading}
              ></textarea>
              {/* {hide ? `${500 - comment.length} characters remaining` : ""} */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-end gap-3 border-0">
          <button
            className="btn-primary"
            onClick={() => {
              handleClose();
              setRating("");
              setRatingAlert(false);
              setComment("");
              // setHide(false)
            }}
            disabled={isLoading}
          >
            {t("cancel")}
          </button>
          {isLoading ? (
            <button className="btn-primary active-page">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            </button>
          ) : (
            <button className="btn-primary active-page" onClick={handleSubmit}>
              {t("submit")}
            </button>
          )}
        </Modal.Footer>
        {/* {error ? <span className="d-flex justify-content-end">Something went wrong.</span> : ""} */}
      </Modal>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={true}
        isConfirmwithNo={true}
        confirmId={""}
        confirmAction={() => {
          setConfirmModal(false);
        }}
        isRightIcon={true}
      />
    </>
  );
};

export default CoachRating;
